<template>
  <div
    :class="widthAuto ? '!w-fit !flex-1' : ''"
    class="xl:w-[300px] h-fit flex flex-none flex-col gap-[4px]"
  >
    <label v-if="label.length" class="flex flex-row-reverse justify-between items-center h-[21px]" for="fname">
    <!-- <label
      v-if="label.length"
      class="flex flex-row-reverse justify-between items-center h-[21px]"
      :for="inputId"
    > -->
      <span class="material-symbols-rounded text-grays-700 text-base">
        <slot name="label_icon"></slot>
      </span>
      <p
        :class="disabled ? 'text-grays-600' : ''"
        class="text-grays-700 text-sm font-regular w-full text-right"
      >
        {{ label }}
      </p>
    </label>
    <div
      ref="defaultInput"
      :class="[disabled ? 'bg-grays-200  hover:border-grays-400' : '']"
      class="w-full py-[7px] px-[12px] flex flex-row-reverse items-center justify-between gap-[8px] rounded border border-grays-400 bg-white hover:border-grays-600"
    >
      <div class="flex flex-row gap-[8px]">
        <slot name="second_right_icon"></slot>
        <slot name="right_icon"></slot>
      </div>
      <input
        ref="input"
        :autocomplete="autocomplete"
        :class="[
          widthAuto ? 'input-width-inherit' : '',
          disabled ? 'text-grays-600 placeholder:text-grays-600' : '',
        ]"
        :dir="dir"
        :disabled="disabled"
        :maxlength="maxlength"
        :placeholder="placeholder"
        :type="type"
        :value="modelValue"
        class="flex flex-1 outline-none bg-transparent font-regular text-base text-grays-900 placeholder:text-grays-700 h-[38px] my-[-7px]"
        v-bind="$attrs"
        @blur="restoreBorderColor"
        @focus="changeBorderColor"
        @input="updateInput"
      />
      <slot name="left_icon"></slot>
    </div>
    <error-block v-if="error" :errorMessage="errorMessage" />
  </div>
</template>

<script>
import ErrorBlock from "@/components/Global/ErrorBlock.vue";

export default {
  name: "input-default",
  components: { ErrorBlock },
  props: {
    type: { type: String, default: "text" },
    maxlength: {
      type: Number,
      default: 524288,
    },
    label: {
      type: String,
      default: "",
    },
    modelValue: [String, Number],
    placeholder: {
      type: String,
      default: "",
    },
    error: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: "",
    },
    widthAuto: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    validator: {
      type: Object,
      default() {
        return {};
      },
    },
    dir: {
      type: String,
      default: "rtl",
    },
    id: { type: String, default: null },
    name: { type: String, default: null },
    autocomplete: { type: String, default: "on" },
  },
  methods: {
    changeBorderColor() {
      if (!this.error && this.$refs.defaultInput) {
        this.$refs.defaultInput.style.borderColor = "#484848";
      }
    },
    restoreBorderColor() {
      if (!this.error && this.$refs.defaultInput) {
        this.$refs.defaultInput.style.borderColor = "";
      }
    },
    errorBorderStyle() {
      if (this.$refs.defaultInput) {
        this.$refs.defaultInput.style.borderColor = this.error ? "#EC3E45" : "";
      }
    },
    updateInput(e) {
      this.$emit("update:modelValue", e.target.value);
    },
  },
  mounted() {
    this.errorBorderStyle();
  },
  watch: {
    error() {
      this.errorBorderStyle();
    },
  },
};
</script>

<style scoped>
.input-width-inherit {
  width: inherit;
}
</style>
